module.exports = __webpack_public_path__ + "static/media/201EC271.decc69ee.jpg";